import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { ContentHeader } from "@cx/ui";
import { errorMessage } from "../../errors";
import { useSession } from "../../session";

/**
 * "Tela de autorização" da Shopee de testes (só no ambiente de testes). Autorizar gera `code` e `shop_id` e segue
 * para o mesmo retorno da Shopee real.
 */
export function ShopeeSandboxConsentPage(): ReactElement {
  const { api } = useSession();
  const { state } = useSearch({ from: "/integracoes/shopee/sandbox" });
  const navigate = useNavigate();
  const authorize = useMutation({
    mutationFn: () =>
      api<{ code: string; shopId: string; state: string }>("/marketplaces/shopee/sandbox/authorize", {
        method: "POST",
        body: JSON.stringify({ state }),
      }),
    onSuccess: (r) => {
      void navigate({
        to: "/integracoes/shopee/retorno",
        search: { code: r.code, shop_id: r.shopId, state: r.state },
        replace: true,
      });
    },
  });
  return (
    <>
      <ContentHeader title="Shopee de testes" breadcrumb={["Preferências", "Integrações", "Shopee"]} />
      <div className="box card p-3" style={{ maxWidth: 560 }}>
        <p>
          O <strong>CX ERP</strong> quer acessar sua loja de testes: anúncios, pedidos e estoque. Nenhuma loja
          real da Shopee é usada.
        </p>
        {authorize.isError && <div className="alert alert-danger py-2">{errorMessage(authorize.error)}</div>}
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-primary"
            disabled={!state || authorize.isPending}
            onClick={() => authorize.mutate()}
          >
            Autorizar
          </button>
          <Link
            className="btn btn-outline-secondary"
            to="/integracoes/shopee/retorno"
            search={{ error: "access_denied" }}
            replace
          >
            Recusar
          </Link>
        </div>
      </div>
    </>
  );
}
